import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  dashedVerticalLine: {
    position: 'absolute',
    width: '1px',
    top: 16,
    bottom: 8,
    background: 'repeating-linear-gradient(to bottom, #C4C4C4 0px, #C4C4C4 6px, transparent 6px, transparent 12px)',
    zIndex: 1
  },
  label: {
    position: 'absolute',
    top: -4,
    fontSize: '12px',
    fontWeight: '500',
    whiteSpace: 'nowrap',
    transform: 'translateX(-50%)',
    textAlign: 'center',
    zIndex: 2
  }
})

export default useStyles
